import axios from "axios"
import { useEffect } from "react"
import { useState } from "react"
import { createContext, useContext } from "react"
import { toast } from "react-toastify"
import { handleError } from "../../user/error"
import { API_URL } from "../../util"

export const InviteContext = createContext()

const useInvites = () => {
  const [invites, setInvites] = useState([])
  const [loading, setLoading] = useState(true)
  const [nr, setNR] = useState(true)

  useEffect(() => {
    const fetchInvites = async () => {
      try {
        const resp = await axios.get(`${API_URL}/invites`)
        const { status, code, data } = resp.data

        if (status === "error") return handleError(code)

        setInvites(data)
      } catch (error) {
        handleError()
      }
    }

    if (nr) {
      fetchInvites()
      setLoading(false)
      setNR(false)
    }
  }, [nr])

  const refetch = (needsLoading = false) => {
    if (needsLoading) setLoading(true)

    setNR(true)
  }

  return { invites, loading, refetch }
}

const InviteContextProvider = ({ children }) => {
  const { invites, loading, refetch } = useInvites()

  const create = async (data, clearForm) => {
    try {
      const reqData = { invite: data }
      const resp = await axios.post(`${API_URL}/invites`, reqData)
      const { status, code } = resp.data

      if (status === "error")
        return handleError(
          code,
          "Убедитесь, что все обязательные поля заполнены и такая код приглашения (email и тип пользователя) уже не добавлен в систему"
        )

      refetch()
      clearForm()
      toast.success("Код приглашения успешно добавлен")
    } catch (error) {
      handleError()
    }
  }

  const value = {
    create,
    invites,
    loading,
    refetch,
  }

  return (
    <InviteContext.Provider value={value}>{children}</InviteContext.Provider>
  )
}

export const useInviteContext = () => {
  const context = useContext(InviteContext)

  return context
}

export default InviteContextProvider
